module.exports = __webpack_public_path__ + "img/shopping-cart.d651cfce.svg";